var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('PwaVideoDetailShare',{attrs:{"feed-page":_vm.isShareDetail ? _vm.FeedPageEnum.VideoDetailShare : _vm.FeedPageEnum.VideoDetail}})
}
var staticRenderFns = []

export { render, staticRenderFns }